export default [
    {
      path: "/auth/login",
      name: "auth",
      component: () => import(`@/pages/Auth/Login.vue`),
      meta: { layout: "auth" }
    },
    {
      path: "/",
      redirect: '/auth/login'
    },
    {
      path: "/dashboard",
      name: "Dashboard_Simantap",
     component: () => import("@/modules/dashboard.vue"),
      meta: { layout: "diklat" ,   public : false  , auth: true  }
    },
    {
      path: "/profile",
      name: "profile",
     component: () => import("@/pages/Profile.vue"),
      meta: { layout: "dashboard" ,   public : false  , auth: true  }
    },
    {
      path: '/sximo/config',
      meta: {  requiresAuth:true ,  layout: "dashboard"  , auth: true  },
      name: 'configuration',
      component: () => import( `@/sximo/CoreConfig.vue` ),
    }, 
    {
      path: '/sximo/users',
      meta: {  layout: "dashboard"  , auth: true  },
      name: 'users',
      component: () => import( `@/sximo/CoreUser.vue` ),
    },
     {
      path: '/sximo/groups',
      meta: {  layout: "dashboard"  , auth: true  },
      name: 'groups',
      component: () => import( `@/sximo/CoreGroup.vue` ),
    },
    {
      path: '/sximo/module',
      meta: {  layout: "dashboard"  , auth: true  },
      name: 'module',
      component: () => import( `@/sximo/CoreModule.vue` ),
    },
    {
      path: '/sximo/database',
      meta: {  layout: "dashboard"  , auth: true  },
      name: 'database',
      component: () => import( `@/sximo/CoreDatabase.vue` ),
    },
     {
      path: '/sximo/mail',
      meta: {  layout: "dashboard"  , auth: true  },
      name: 'mail',
      component: () => import( `@/sximo/CoreMail.vue` ),
    },
      {
      path: '/sximo/notification',
      meta: {  layout: "dashboard"  , auth: true  },
      name: 'notification',
      component: () => import( `@/sximo/CoreNotification.vue` ),
    },   
];



// WEBPACK FOOTER //
// ./src/router/routes.js